import React from 'react';
import { STATUS, STATUS_DEFAULT } from '../lib/tokens';

export default function StatusBadge({ status, label, className = '' }) {
  const s = status ? String(status).toLowerCase() : '';
  const cfg = STATUS[s] || STATUS_DEFAULT;
  const displayLabel = label || (s ? s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : '—');
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold ${cfg.bg} ${cfg.text} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {displayLabel}
    </span>
  );
}
